import Skeleton from './Skeleton'

// Mirrors the product card markup in Shop.jsx (default) and the smaller
// "fresh-pick-card" in Home.jsx (compact) so the layout doesn't jump once
// real data replaces the placeholder.
const ProductCardSkeleton = ({ compact = false }) => (
  <div className="bg-white rounded-2xl shadow-md overflow-hidden">
    <div className="h-1 bg-gray-200" />
    <div className={compact ? 'p-5' : 'p-6'}>
      <Skeleton className={`w-full rounded-xl mb-4 ${compact ? 'h-36' : 'h-48'}`} />
      <Skeleton className={`h-5 mb-2 ${compact ? 'w-2/3' : 'w-3/4'}`} />
      {!compact && <Skeleton className="h-4 w-1/3 mb-3" />}
      <Skeleton className={`h-6 w-1/2 ${compact ? 'mb-4' : 'mb-4'}`} />
      <Skeleton className={`w-full rounded-full ${compact ? 'h-9' : 'h-10'}`} />
    </div>
  </div>
)

export default ProductCardSkeleton
